export default __webpack_public_path__ + "static/media/gallery_00.3ac67e36.jpg";